import { useState, useEffect, useCallback } from 'react';

export const useTimer = (initialTime: number) => {
    const [time, setTime] = useState(initialTime);

    const resetTimer = useCallback(() => {
        setTime(initialTime);
    }, [initialTime]);

    useEffect(() => {
        if (time > 0) {
            const timerId = setTimeout(() => {
                setTime(time - 1);
            }, 1000);
            return () => clearTimeout(timerId);
        }
    }, [time]);

    return { time, resetTimer };
};